import { gql } from 'graphql-request';

import { FRAGMENT_AGENT_OFFICE } from './fragments/ListingDetails.graphql';

export const FRAGMENT_AGENT_LISTING_NODE = gql`
  ${FRAGMENT_AGENT_OFFICE}
  fragment AgentListingNode on Listing {
    hcAddressSlug
    entityId
    mls {
      hcMlsId
      name
      nameShort
      regulations {
        logo
      }
    }
    agentOffice {
      hc {
        agentOffice {
          ...AgentOffice
        }
      }
    }
  }
`;

export const QUERY_AGENTS = gql`
  ${FRAGMENT_AGENT_LISTING_NODE}
  query Agents($email: String!) {
    # HC CAPABILITY: platform-search-experience
    # HC CAPABILITY: pexp-product-access
    # Note: tying this query to "pexp-product-access" since this capability is granted to every self-serve
    # user immediately after signup (this query is used in onboarding flow right after signup)
    agents(agent: { email: $email }) {
      edges {
        node {
          email
          name
          office
          phone
          licenseNumber
          listings {
            edges {
              node {
                ...AgentListingNode
              }
            }
          }
          identifiers {
            mlsAgentIds {
              hcMlsId
              mlsAgentId
            }
          }
        }
      }
    }
  }
`;

export const QUERY_AGENT_LISTINGS_FOR_VERIFICATION = gql`
  ${FRAGMENT_AGENT_LISTING_NODE}
  query AgentVerificationListings($mlsId: String!) {
    # HC CAPABILITY: agent-verification
    agents(agent: { mlsId: $mlsId }) {
      edges {
        node {
          email
          name
          office
          phone
          licenseNumber
          listings {
            edges {
              node {
                ...AgentListingNode
              }
            }
          }
          identifiers {
            mlsAgentIds {
              mlsAgentId
              hcMlsId
            }
          }
        }
      }
    }
  }
`;
